import { XHR } from "./polling-xhr.js";
import { WS } from "./websocket.js";
export const transports = {
    websocket: WS,
    polling: XHR
};



//////////////////
// WEBPACK FOOTER
// ./~/engine.io-client/build/esm/transports/index.js
// module id = 630
// module chunks = 0